import { Snapshot } from '@shared/domain/snapshot/snapshot.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { SnapshotDto } from './dto/snapshotDto';
import { configuration } from 'configuration';

export const snapshotRepositoryImplementation = {
  getSnapshots: async (
    countryCode: string
  ): Promise<Snapshot[]> => {
    const response = await httpClient.get<SnapshotDto[]>(
      `${configuration.api.baseUrl}/api/${countryCode}/snapshots`,
      {
      }
    );

    return response as Snapshot[];
  },

  createSnapshot: async (
    countryCode: string,
    name: string
  ): Promise<Snapshot> => {
    const response = await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/snapshots/create`,
      {
        name: name
      }
    );

    return (await response.json()) as Snapshot
  },

  restoreSnapshot: async (
    countryCode: string,
    snapshotId: number
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/snapshots/restore`,
      {
        snapshotId: snapshotId
      }
    );
  }
};
